exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr-confirm{height:40px;max-height:0;visibility:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;cursor:pointer;background:rgba(0,0,0,.06)}.flatpickr-confirm svg path{fill:inherit}.flatpickr-confirm.darkTheme{color:#fff;fill:#fff}.flatpickr-confirm.visible{max-height:40px;visibility:visible}", ""]);

// exports
